<template>
    <div>
        <download-popup
            :data-to-show="isDownloadPopupDisplayed"
            @close="changeStateDownloadPopup(false)"
            @downloadPDF="downloadPDF"
        />

        <mise-en-forme v-if="currentStep === 'shaping'" class="px-10" />

        <titre-et-accroche v-if="currentStep === 'title'" class="px-10" />

        <informations-personnelles v-if="currentStep === 'personnal'" class="px-10"/>

        <formations v-if="currentStep === 'formations'" />

        <experiences-professionnelles v-if="currentStep === 'pro'" />

        <competences v-if="currentStep === 'comp'" />

        <langues v-if="currentStep === 'langues'" />

        <centres-interets v-if="currentStep === 'hobbies'" />

        <cles-reussite v-if="currentStep === 'success'" />

        <besoin-travail v-if="currentStep === 'needs'" />

        <atouts v-if="currentStep === 'atouts'" />

        <div class="flex justify-center md:justify-end space-x-5 mt-10 mx-10">
            <action-button
                v-if="positionCvPage > 0"
                border-color="border-pink-600"
                text-color="text-pink-600"
                bg-color="bg-pink-100"
                bg-color-square="bg-pink-100"
                libelle="Précédent"
                :uppercase="true"
                @clickAction="SET_CURRENTSTEP(cvPages[positionCvPage-1].name)"
            />
            <action-button
            v-show="positionCvPage < cvPages.length-1"
                border-color="border-pink-600"
                text-color="text-white"
                bg-color="bg-pink-600"
                bg-color-square="bg-pink-600"
                libelle="Suivant"
                type-shadow="shadow-pink"
                :uppercase="true"
                @clickAction="SET_CURRENTSTEP(cvPages[positionCvPage+1].name)"
            />
            <action-button
                v-show="positionCvPage === cvPages.length-1"
                border-color="border-pink-600"
                text-color="text-white"
                bg-color="bg-pink-600"
                bg-color-square="bg-pink-600"
                libelle="Suivant"
                type-shadow="shadow-pink"
                :uppercase="true"
                @clickAction="changeStateDownloadPopup(true)"
            />
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import Constants from './../../constants';

import DownloadPopup from './popup/DownloadPopup.vue';
import MiseEnForme from './pages/MiseEnForme.vue';
import TitreEtAccroche from './pages/TitreEtAccroche.vue';
import InformationsPersonnelles from './pages/InformationsPersonnelles.vue';
import Formations from './pages/Formations.vue';
import ClesReussite from './pages/ClesReussite.vue';
import ExperiencesProfessionnelles from './pages/ExperiencesProfessionnelles.vue';
import Competences from './pages/Competences.vue';
import Langues from './pages/Langues.vue';
import CentresInterets from './pages/CentresInterets.vue';
import Atouts from './pages/Atouts.vue';
import BesoinTravail from './pages/BesoinTravail.vue';

import ActionButton from './../../components/ActionButton.vue';

export default {
  name: 'CvFormulaire',

  components:{
    DownloadPopup,
    MiseEnForme,
    TitreEtAccroche,
    InformationsPersonnelles,
    Formations,
    ExperiencesProfessionnelles,
    Competences,
    Langues,
    CentresInterets,
    ActionButton,
    ClesReussite,
    Atouts,
    BesoinTravail,
  },

  data(){
    return {
      constants: Constants,
      isDownloadPopupDisplayed:false,
    };
  },

  methods:{
    ...mapMutations({
      SET_CURRENTSTEP: 'curriculumVitae/SET_CURRENTSTEP',
    }),

    downloadPDF() {
      this.$emit('downloadPDF');
      this.changeStateDownloadPopup(false);
    },

    changeStateDownloadPopup(state){
      this.isDownloadPopupDisplayed = state;
    }
  },

  computed:{
    ...mapGetters({
      listCvs:'curriculumVitae/listCvs',
      form: 'curriculumVitae/form',
      currentStep: 'curriculumVitae/currentStep',
    }),

    idCv(){
      return this.$route.params.id;
    },

    cvPages(){
      return Constants.CV_PAGES[this.form.type];
    },

    positionCvPage(){
      return this.cvPages.findIndex((page) => page.name === this.currentStep);
    }
  }
};
</script>
